import { useEffect } from "react";

const MAILCHIMP_SCRIPT_SRC =
  "https://chimpstatic.com/mcjs-connected/js/users/316c10e2bd35b1a092de997e0/1ed168280b782275bc744d8dc.js";

const PopupNewsletter = () => {
  useEffect(() => {
    if (document.getElementById("mcjs")) return;

    const script = document.createElement("script");
    script.id = "mcjs";
    script.src = MAILCHIMP_SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById("mcjs");
      if (existing) existing.remove();
    };
  }, []);

  return null;
};

export default PopupNewsletter;